import { EyeOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import "./ViewDetailButton.scss";

type ViewDetailButtonProps = {
  title?: string;
  onClick?: () => void;
  // Có href thì mở liên kết ở tab mới
  href?: string;
};

// Nút icon con mắt "Xem chi tiết" đặt cạnh một giá trị (khách hàng, báo giá...); vuông, cao bằng ô nhập cùng hàng (chữ nằm ở tooltip)
export const ViewDetailButton = ({ title, onClick, href }: ViewDetailButtonProps) => {
  const button = (
    <Button
      className="viewDetailButton"
      icon={<EyeOutlined />}
      onClick={onClick}
      href={href}
      target={href ? "_blank" : undefined}
      rel={href ? "noopener noreferrer" : undefined}
      aria-label={title || "Xem chi tiết"}
    />
  );

  return title ? <Tooltip title={title}>{button}</Tooltip> : button;
};
